export default {"src":"/_next/static/media/greenfield-deployment.100dcdef.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};